"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Utilities_1 = require("office-ui-fabric-react/lib/Utilities");
var Image_1 = require("office-ui-fabric-react/lib/Image");
var FileField_1 = require("@twii/core-ui-fabric/lib/component/FileField");
var ImageFile = /** @class */ (function (_super) {
    __extends(ImageFile, _super);
    function ImageFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageFile.prototype._setBlobUrl = function (file) {
        try {
            this._blobUrl = URL.createObjectURL(file);
        }
        catch (e) { }
    };
    ImageFile.prototype._cleanupBlobUrl = function () {
        if (this._blobUrl) {
            try {
                URL.revokeObjectURL(this._blobUrl);
            }
            catch (e) { }
            this._blobUrl = undefined;
        }
    };
    ImageFile.prototype.componentWillMount = function () {
        this._setBlobUrl(this.props.file);
    };
    ImageFile.prototype.componentWillUnmount = function () {
        this._cleanupBlobUrl();
    };
    ImageFile.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.file !== this.props.file) {
            this._cleanupBlobUrl();
            this._setBlobUrl(nextProps.file);
        }
    };
    ImageFile.prototype.render = function () {
        return React.createElement(Image_1.Image, { src: this._blobUrl, width: this.props.width, height: this.props.height, alt: this.props.alt || this.props.file.name });
    };
    return ImageFile;
}(React.Component));
exports.ImageFile = ImageFile;
var defaultRenderImageSelect = function (props) {
    return React.createElement(Image_1.Image, { src: props.image.url, width: props.width, height: props.height, alt: props.label });
};
var defaultRenderImageFile = function (file, props) {
    return React.createElement(ImageFile, { file: file, width: props.width, height: props.height, alt: props.label });
};
var ImageField = /** @class */ (function (_super) {
    __extends(ImageField, _super);
    function ImageField(props) {
        var _this = _super.call(this, props) || this;
        _this._onRenderFile = function (file) {
            return (_this.props.onRenderImageFile || defaultRenderImageFile)(file, _this.props);
        };
        _this._onRenderFiles = function (files) {
            if (files && files.length > 0) {
                var file = files[0];
                return _this._onRenderFile(file);
            }
            return null;
        };
        _this._onChange = function (files) {
            if (_this.props.onChange) {
                _this.props.onChange(files && files.length > 0 ? { file: files[0] } : undefined);
            }
        };
        _this._onRenderSelectImage = function () {
            return (_this.props.onRenderSelect || defaultRenderImageSelect)(_this.props);
        };
        _this._onClear = function () {
            if (_this.props.onChange) {
                _this.props.onChange(undefined);
            }
        };
        _this.state = {};
        _this._id = Utilities_1.getId("image-field");
        return _this;
    }
    ImageField.prototype.render = function () {
        return React.createElement(FileField_1.FileField, { files: this.props.image && this.props.image.file ? [this.props.image.file] : undefined, label: this.props.label, multiple: false, accept: "image/*", defaultSelectText: this.props.defaultSelectText || "Select an Image...", onRenderSelect: this.props.image && this.props.image.url ? this._onRenderSelectImage : undefined, onRenderFiles: this._onRenderFiles, onChange: this._onChange, onClear: this.props.image ? this._onClear : undefined });
    };
    return ImageField;
}(React.Component));
exports.ImageField = ImageField;
